import { ArrowUpToLineIcon } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { ClaimAirdropRewardsAction } from './types'

export interface ClaimAirdropRewardsActionRowProps extends ActionRowBaseProps {
  action: ClaimAirdropRewardsAction
}

export function ClaimAirdropRewardsActionRow({ action, ...props }: ClaimAirdropRewardsActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowUpToLineIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[action.token]} />
        {airdropSourceToActionLabel[action.source]}
      </ActionRow.Title>

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Claim</ActionRow.Trigger>
    </ActionRow>
  )
}

const airdropSourceToActionLabel = {
  'spk-ignition-airdrop': 'Claim Spark Ignition Airdrop',
  'spk-social-and-prefarming-airdrop': 'Claim Social and Pre-farming Airdrop',
  'spk-cookie3-airdrop': 'Claim Cookie DAO Campaign Airdrop',
}
